module.exports = __webpack_public_path__ + "static/media/2019-image.67aa5a8e.png";